<template>
  <BlockFieldset class="project-extended-configuration">
    <b-row>
      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('cascadeConnectionState')"
          label-for="cascadeConnectionState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('cascadeConnectionState')"
            v-model="project.solarPlant.cascadeConnectionState"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('networkSupplyManagementState')"
          label-for="networkSupplyManagementState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('networkSupplyManagementState')"
            v-model="project.solarPlant.networkSupplyManagementState"
            :options="getNetworkSupplyManagementStates"
            :show-labels="false"
            :allow-empty="true"
            @select="onNetworkSupplyManagementState"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('networkSupplyManagementPermanentRestrictionState')"
          label-for="networkSupplyManagementPermanentRestrictionState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :placeholder="$t('networkSupplyManagementPermanentRestrictionState')"
            v-model="project.solarPlant.networkSupplyManagementPermanentRestrictionState"
            :options="getNetworkSupplyManagementPermanentRestrictionStates"
            :show-labels="false"
            :allow-empty="true"
            :disabled="
              isBlockReadOnly || networkSupplyManagementPermanentRestrictionStateIsDisabled
            "
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('netOutputState')"
          label-for="netOutputState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('netOutputState') + ' ' + $t('select')"
            v-model="project.solarPlant.netOutputStates"
            :options="getNetOutputStates"
            :close-on-select="false"
            :clear-on-select="false"
            :multiple="true"
            :taggable="true"
            :show-labels="true"
            :allow-empty="true"
            :selectLabel="$t('select')"
            :selectedLabel="$t('selected')"
            :deselectLabel="$t('remove_selection')"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
            <template slot="tag" slot-scope="{ option }">
              <b-badge>
                {{ $t(option) }}
              </b-badge>
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('electricMeterMountingState')"
          label-for="electricMeterMountingState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('electricMeterMountingState')"
            v-model="project.solarPlant.electricMeterMountingState"
            :options="getElectricMeterMountingStates"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('yearlyPower')"
          label-for="yearlyPower"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            :disabled="isBlockReadOnly"
            v-model="project.solarPlant.yearlyPower"
            mode="decimal"
            :minFractionDigits="2"
            suffix=" kWh"
            locale="de-DE"
            :placeholder="$t('yearlyPower')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('houseFuseAmpere')"
          label-for="houseFuseAmpere"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            :disabled="isBlockReadOnly"
            v-model="project.solarPlant.houseFuseAmpere"
            suffix=" A"
            locale="de-DE"
            :placeholder="$t('houseFuseAmpere')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('electricMeterCombinationState')"
          label-for="electricMeterCombinationState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('electricMeterCombinationState')"
            v-model="project.solarPlant.electricMeterCombinationState"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>
      </b-col>
      <b-col lg="6" md="6" sm="12">
        <b-form-group
          horizontal
          :label="$t('electricMeterDeregistrationState')"
          label-for="electricMeterDeregistrationState"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('electricMeterDeregistrationState')"
            v-model="project.solarPlant.electricMeterDeregistrationState"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('solarPlantType')"
          label-for="solarPlantType"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('solarPlantType')"
            v-model="project.solarPlant.solarPlantType"
            :options="getEnumValues('SolarPlantType')"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('islandOperationIntended')"
          label-for="islandOperationIntended"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('islandOperationIntended')"
            v-model="project.solarPlant.islandOperationIntended"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('motorStartup')"
          label-for="motorStartup"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('motorStartup')"
            v-model="project.solarPlant.motorStartup"
            :options="optionsYesNo"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }"
              ><b-badge :variant="yesNoColor(option)">{{ $t(option) }}</b-badge></template
            >
            <template slot="option" slot-scope="{ option }">
              <b-badge :variant="yesNoColor(option)">
                {{ $t(option) }}
              </b-badge></template
            >
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('networkSupplyType')"
          label-for="networkSupplyType"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <multiselect
            :disabled="isBlockReadOnly"
            :placeholder="$t('networkSupplyType')"
            v-model="project.solarPlant.networkSupplyType"
            :options="getEnumValues('NetworkSupplyType')"
            :show-labels="false"
            :allow-empty="true"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ $t(option) }}</template>
            <template slot="option" slot-scope="{ option }">
              {{ $t(option) }}
            </template>
          </multiselect>
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('measuringConcept')"
          label-for="measuringConcept"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <b-form-input
            v-model="project.solarPlant.measuringConcept"
            type="text"
            :placeholder="$t('measuringConcept')"
          />
        </b-form-group>

        <b-form-group
          horizontal
          :label="$t('wireCrossSectionMainBus')"
          label-for="wireCrossSectionMainBus"
          label-class="text-md-right"
          :label-cols="4"
          breakpoint="md"
        >
          <InputNumber
            :disabled="isBlockReadOnly"
            v-model="project.solarPlant.wireCrossSectionMainBus"
            suffix=" mm²"
            locale="de-DE"
            :min-fraction-digits="0"
            :max-fraction-digits="2"
            :placeholder="$t('wireCrossSectionMainBus')"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <div v-if="!isBlockReadOnly" class="text-right mt-2">
      <b-button variant="bg" :disabled="isSaving" @click="save">
        {{ $t('saveNamed', { name: $t('extendedConfiguration') }) }}
      </b-button>
    </div>
  </BlockFieldset>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import InputNumber from 'primevue/inputnumber';
import { yesNo } from '@/helpers/enums';
import { getYesNoStateColor } from '@/helpers/colors';
import BlockFieldset from '@/components/Access/BlockFieldset.vue';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import { BlockSaveMixin } from '@/mixins/blockSave';
import { toProjectExtendedConfigurationInput } from './projectExtendedConfigurationInput';

/**
 * Block project-extended-configuration (ADR 0006 D3): grid connection and metering fields of
 * the solar plant, saved through its own mutation with its own button. Emits `dirty` (boolean)
 * and `saved`.
 */
export default {
  name: 'ProjectExtendedConfiguration',
  components: {
    BlockFieldset,
    Multiselect,
    InputNumber,
  },
  mixins: [AccessBlockMixin, BlockSaveMixin],
  props: {
    blockId: { type: String, required: true },
    project: { type: Object, required: true },
  },
  computed: {
    ...mapGetters([
      'getNetworkSupplyManagementStates',
      'getNetworkSupplyManagementPermanentRestrictionStates',
      'getNetOutputStates',
      'getElectricMeterMountingStates',
      'getEnumValues',
    ]),
    blockInput() {
      return toProjectExtendedConfigurationInput(this.project.solarPlant);
    },
    networkSupplyManagementPermanentRestrictionStateIsDisabled() {
      return this.project.solarPlant.networkSupplyManagementState !== 'PERMANENT_RESTRICTION';
    },
    optionsYesNo() {
      return yesNo();
    },
  },
  methods: {
    ...mapActions([
      'fetchNetworkSupplyManagementStates',
      'fetchNetworkSupplyManagementPermanentRestrictionStates',
      'fetchNetOutputStates',
      'fetchElectricMeterMountingStates',
      'fetchEnumValues',
      'updateProjectExtendedConfiguration',
    ]),
    saveBlockInput(input) {
      return this.updateProjectExtendedConfiguration({ projectNumber: this.project.number, input });
    },
    onNetworkSupplyManagementState(state) {
      if (state === 'FRE' || state === 'NONE') {
        this.project.solarPlant.networkSupplyManagementPermanentRestrictionState = null;
      }
    },
    yesNoColor(state) {
      return getYesNoStateColor(state);
    },
    async setup() {
      try {
        await Promise.all([
          this.fetchNetworkSupplyManagementStates(),
          this.fetchNetworkSupplyManagementPermanentRestrictionStates(),
          this.fetchNetOutputStates(),
          this.fetchElectricMeterMountingStates(),
          this.fetchEnumValues('SolarPlantType'),
          this.fetchEnumValues('NetworkSupplyType'),
        ]);
      } catch (error) {
        console.error('Error in setup:', error);
      }
    },
  },
  async mounted() {
    await this.setup();
  },
};
</script>
